import { IProcessOptions } from "./interfaces";

// Constants
const PROCESS_TYPES = {
	CSV: "csv",
	JOURNAL: "journal",
} as const;

const FORMAT_TYPES = {
	ITEMIZED: "itemized",
	SUMMARY: "summary",
} as const;

const EXPORT_PROCESS_TYPES: IProcessOptions[] = [
	{
		key: "csv",
		label: "To CSV",
		value: PROCESS_TYPES.CSV,
		disabled: false,
	},
	{
		key: "journal",
		label: "Add to General Journal",
		value: PROCESS_TYPES.JOURNAL,
		disabled: false,
	},
];

const EXPORT_FORMAT_TYPES: IProcessOptions[] = [
	{
		key: "itemized",
		label: "Itemized",
		value: FORMAT_TYPES.ITEMIZED,
		disabled: false,
	},
	{
		key: "summary",
		label: "Summary",
		value: FORMAT_TYPES.SUMMARY,
		disabled: false,
	},
];

export { PROCESS_TYPES, FORMAT_TYPES, EXPORT_PROCESS_TYPES, EXPORT_FORMAT_TYPES };
